import {getBookIdWithPrefix} from "../../../utils/content/content";

/**
 *
 * @param {*} data
 * @param {*} query
 * @returns {ShortcutParams[]}
 */
export const normilizeShortcut = (data, query) => {
  const outData = {
    ...data,
    query,
  };

  outData.shortCutType = data.type;

  if (data.type === "search") {
    outData.cutQuery = data.params.query;
  } else {
    outData.cutQuery = "";
  }
  if (data.params && data.params.pubnr) {
    outData.bookId = getBookIdWithPrefix(data.params.pubnr);
  }
  if (data.para_id) {
    outData.bookId = getBookIdWithPrefix(data.para_id);
    outData.paraId = data.para_id;
  }
  if (data.params && data.params.chapter) {
    outData.bookId = getBookIdWithPrefix(data.params.chapter);
    outData.paraId = data.params.chapter;
  }

  return outData;
};

export const processCode = (query) => {
  const trimmed = query.trim();
  const rx = /^([0-9]*[a-z]+)([0-9]+[0-9.:]*)$/i;
  if (!rx.test(trimmed)) {
    return [query];
  }
  // else
  // extended code
  const res = trimmed.match(rx);
  return [`${res[1]} ${res[2]}`, `${res[1]}${res[2]}`];
};
